export const QUERY_CACHE_KEYS = {
  ivSDKSchema: 'ivSDKSchema',
  guestSDKAuth: 'guestSDKAuth',
  formFields: 'formFields',
  reservation: 'reservation',
  apiClient: 'apiClient',
  locations: 'locations',
  phoneCodes: 'phoneCodes',
  summary: 'summary',
  housing: 'housing',
  reservationSearchHousings: 'reservationSearchHousings',
  customForm: 'customForm',
  customFormById: 'customFormById',
  guestGroup: 'guestGroup',
  guest: 'guest',
  paymentSettings: 'paymentSettings',
  reservationPayments: 'reservationPayments',
  paymentsCart: 'paymentsCart',
  taxExemptions: 'taxExemptions',
  guidebooksByHousing: 'guidebooksByHousing',
  season: 'season',
  seasonGuests: 'seasonGuests',
  propertyProtections: 'propertyProtections',
  insuranceSetup: 'insuranceSetup',
  paginatedSpanishResidenceCities: 'paginatedSpanishResidenceCities',
  paginatedCountriesList: 'paginatedCountriesList',
  paginatedProvincesList: 'paginatedProvincesList',
  paginatedCitiesList: 'paginatedCitiesList',
  paginatedDistrictsList: 'paginatedDistrictsList',
  paginatedMunicipalitiesList: 'paginatedMunicipalitiesList',
  paginatedPhoneCodesList: 'paginatedPhoneCodesList',
  orderHistory: 'orderHistory',
  deleteDeal: 'deleteDeal',
  createOrUpdateBulkLock: 'createOrUpdateBulkLock',
  privacyPolicySettings: 'privacyPolicySettings',
  locks: 'locks',
  lockConditions: 'lockConditions',
  unlockDoor: 'unlockDoor',
  locksRooms: 'locksRooms',
  downloadFileDocuments: 'downloadFileDocuments',
  template: 'template',
  contracts: 'contracts',
  reservationBookingReference: 'reservationBookingReference',
  housingLocation: 'housingLocation',
  offers: 'offers',
  offer: 'offer',
  topOffers: 'topOffers',
  guruWalkTours: 'guruWalkTours',
  radicalStorageNearby: 'radicalStorageNearby',
  deals: 'deals',
  guidebooks: 'guidebooks',
  guidebook: 'guidebook',
  guidebookGroups: 'guidebookGroups',
  ivIntent: 'ivIntent',
  user: 'user',
  participants: 'participants',
  verificationSettings: 'verificationSettings',
  checkoutSettings: 'checkoutSettings',
  checkoutFeedback: 'checkoutFeedback',
  multiPayment: 'multiPayment',
  addonMultiPayment: 'addonMultiPayment',
  esimPackages: 'esimPackages',
  esims: 'esims',
  esimFeature: 'esimFeature',
  printedCards: 'printedCards',
  chatRoom: 'chatRoom',
  chatMessages: 'chatMessages',
  chatSettings: 'chatSettings',
  communicationUserPreferences: 'communicationUserPreferences',
  autofillDocumentChoices: 'autofillDocumentChoices',
  travelGuide: 'travelGuide',
  travelGuideRun: 'travelGuideRun',
  travelGuideThumbnail: 'travelGuideThumbnail',
} as const;
